import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OE_AttendanceListInput.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { OrchestraBooking, OrchestraDutyType, OrchestraEmployment } from "./OE_AttendanceListTypes";
import Edit from '../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';

class OE_AttendanceListInput extends compose(_StatefulSection) {
    templateString: any = template;

    private availableDutyTypes: Array<OrchestraDutyType>;
    private defaultPresentTypeID: string;

    private confirmationStatusInput: MdsLax<InstanceType<typeof Edit>>;
    //private actualDutyTypeInput: RadioGroup;
    private actualDutyTypeInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private confirmationStatusContainer: HTMLElement;

    private noteInput: MdsLax<InstanceType<typeof Edit>>;

    private employmentHeading: HTMLElement;


    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.employmentHeading.innerHTML = this.getAttributeValue("ref_associate.gDisp_Name_Firstname");

        let currentDutyType = this.getAttributeValue("ref_vt_duty_type_actual");
        let bSuppressChange = true;

        let checkinStatus = this.getAttributeValue("presence_confirmation_status");
        if (checkinStatus === "present" && !currentDutyType) {
            currentDutyType = this.defaultPresentTypeID;
            this.setAttributeValue("ref_vt_duty_type_actual", currentDutyType);
        }

        this.actualDutyTypeInput.setData(currentDutyType, this.availableDutyTypes, bSuppressChange, "description", "ID");
        this.setInputColor();
    }

    private setInputColor() {
        //let radioValue = this.actualDutyTypeInput.getValue();
        //let dutyTypeEntity: any = this.actualDutyTypeInput.getOptionByValue(radioValue);
        let dutyTypeEntity: any = this.actualDutyTypeInput.getValue(true);
        //if (dutyTypeEntity) dutyTypeEntity = dutyTypeEntity.valueSource.entity as OrchestraDutyType;

        //RESET
        this.UiModder.domClass.remove(this.domNode, "warningBorder");
        this.UiModder.domClass.remove(this.domNode, "successBorder");
        this.UiModder.domClass.remove(this.employmentHeading, "warningText");
        this.UiModder.domClass.remove(this.employmentHeading, "successText");


        if (dutyTypeEntity && dutyTypeEntity.Classname === "present_type") {
            this.UiModder.domClass.add(this.domNode, "successBorder");
            this.UiModder.domClass.add(this.employmentHeading, "successText");
        } else if (dutyTypeEntity && dutyTypeEntity.Classname === "absenteeism_type") {
            this.UiModder.domClass.add(this.domNode, "warningBorder");
            this.UiModder.domClass.add(this.employmentHeading, "warningText");
        }
    }

    setAvailableDutyTypes(availableDutyTypes: Array<OrchestraDutyType>, defaultPresentTypeID: string) {
        let currentDutyType = this.getAttributeValue("ref_vt_duty_type_actual");
        this.availableDutyTypes = availableDutyTypes;
        this.actualDutyTypeInput.setData(currentDutyType, availableDutyTypes, true, "description", "ID", "coloration");
        this.defaultPresentTypeID = defaultPresentTypeID;
    }

    private _onDutyTypeInputChange(e) {

    }
    private _onRadioChange(e) {
        //if (e) {
        //    let dutyType = this.actualDutyTypeInput.getOptionByValue(e[0]).valueSource.entity;
        //    this.setAttributeValue("ref_vt_duty_type_actual", dutyType);
        //}

    }

    setReadonly(bIsReadonly: boolean) {
        this.actualDutyTypeInput.setReadonly(bIsReadonly);
        this.noteInput.setReadonly(bIsReadonly);
    }

    protected _onChanged(attribute: string, value: any): void {
        super._onChanged.apply(this, arguments as any);

        switch (attribute) {
            case "ref_vt_duty_type_actual":
                console.log(value);
                //let dutyType = this.actualDutyTypeInput.getOptionByValue(value);
                //console.log(dutyType);

                this.setAttributeValue("ref_vt_duty_type_actual", value);
                this.setInputColor();
                break;
        }
        this._emitChangeEvent();
    }

    private _emitChangeEvent() {
        let currentData = this.getCurrentData();
        this.emit("changed", currentData);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.hasFeature("OrchestraEmployment/SelfCheckin")) {
            this.hideNode(this.confirmationStatusInput, true);
            this.hideNode(this.confirmationStatusContainer, true);
            this.UiModder.domConstruct.destroy(this.confirmationStatusInput.domNode);
            this.UiModder.domConstruct.destroy(this.confirmationStatusContainer);
        }

        //this.actualDutyTypeInput.setAlignment("horizontal");

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OE_AttendanceListInput);
